import React, { useRef, useState, useEffect } from 'react';
import { cn } from '../lib/utils';

export default function OverlayTextArea({
  value,
  onChange,
  limit,
  limitType,
  className,
  ...props
}) {
  const [text, setText] = useState(value || '');
  const textRef = useRef(null);
  const highlightRef = useRef(null);

  useEffect(() => {
    setText(value || '');
  }, [value]);

  const handleInput = (e) => {
    const newVal = e.target.value;
    setText(newVal);
    onChange && onChange(newVal);
  };

  const handleScroll = (e) => {
    if (highlightRef.current) {
      highlightRef.current.scrollTop = e.target.scrollTop;
    }
  };

  function escapeHtml(str = '') {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\n/g, '<br />');
  }

  let highlightHTML;

  if (typeof limit === 'number') {
    if (limitType === 'char') {
      const normalText = escapeHtml(value.slice(0, limit));
      const excessText = escapeHtml(value.slice(limit));
      highlightHTML = normalText + 
        (excessText ? `<span style="background-color: rgba(228, 88, 88, 0.1)">${excessText}</span>` : '');
    } else {
      const words = value.split(/\s+/);
      if (words.length <= limit) {
        highlightHTML = escapeHtml(value);
      } else {
        const normalWords = words.slice(0, limit).join(' ');
        const excessWords = words.slice(limit).join(' ');
        highlightHTML = `${escapeHtml(normalWords)}<span style="background-color: rgba(228, 88, 88, 0.1)"> ${escapeHtml(excessWords)}</span>`;
      }
    }
  } else {
    highlightHTML = escapeHtml(value);
  }

  return (
    <div className={cn(
      "relative min-h-[200px] w-full rounded-lg border-2 border-border bg-card",
      "transition-shadow focus-within:shadow-md",
      className
    )}>
      <div
        ref={highlightRef}
        className={cn(
          "pointer-events-none absolute inset-0 overflow-y-auto whitespace-pre-wrap break-words p-3",
          "font-sans text-base leading-relaxed text-transparent"
        )}
        style={{
          WebkitTextFillColor: 'transparent'
        }}
        dangerouslySetInnerHTML={{ __html: highlightHTML }}
      />
      <textarea
        ref={textRef}
        value={text}
        onChange={handleInput}
        onScroll={handleScroll}
        className={cn(
          "relative h-full w-full resize-none rounded-lg bg-transparent p-3",
          "font-sans text-base leading-relaxed text-text-primary",
          "placeholder:text-text-disabled",
          "focus:outline-none focus:ring-2 focus:ring-purple focus:ring-offset-2",
        )}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          color: 'inherit',
        }}
        {...props}
      />
    </div>
  );
} 